<template>
  <!-- 表单项校验配置
       @author: 王汝鹏
       @date: 2019-12-17
   -->
  <div class="setting-item">
    <el-form-item label="校验"> 
      <!-- 必填规则 -->
      <el-checkbox class="setting-validator_require" 
                   v-model="isRequire">
                   必填</el-checkbox>
      <!-- 内容校验规则 -->
      <el-select class="setting-validator_rule" 
                 v-model="ruleSelected" 
                 v-show="showRuleSelect"
                 placeholder="请选择"
                 clearable>
        <el-option v-for="item in formValidatorRuleList"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <!-- 内容长度限制 -->
      <div class="setting-validator_limit"
           v-show="showLimit">
        <el-input v-model.number="minValueProxy" placeholder="最小位数"></el-input>
        <span>--</span>
        <el-input v-model.number="maxValueProxy" placeholder="最大位数"></el-input>
      </div>
      <!-- 是否转大写 -->
      <el-checkbox class="setting-validator_money" 
                   v-show="showMoney"
                   v-model="isMoney">
                   转大写</el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
/** 配置数据 ::: 
 *  @data {Array} formValidatorRuleList 表单项校验规则配置选项
 */
import { formValidatorRuleList } from '@/assets/js/config_dictionary.js';
/** 混入方法 ::: 
 *  @mixin mixValueWatch value参数操作混入方法
 */
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
import { mapComputed } from '@/mixins/common/mix_value_watch.js';


export default {
  mixins: [ mixValueWatch ],
  data() {
    return {
      formValidatorRuleList,
      validatorTimer: null,
    }
  },
  computed: {
    /** @name 表单项校验规则
     *  @description 
     *  - isRequire {Boolean} 是否必填
     *  - ruleSelected {String} 校验规则
     *  - mixValue {Number} 内容 最小值/最小长度
     *  - maxValue {Number} 内容 最大值/最大长度
     *  - isMoney {Boolean} 是否为金额/是否转大写
     *  @author 王汝鹏
     *  @version 2019-12-17
     */
    ...mapComputed({
      isRequire: { 
        parent: i => i.baseOption.validator,
        attr: "isRequire" 
      },
      ruleSelected: { 
        parent: i => i.baseOption.validator,
        attr: "ruleSelected" 
      },
      minValue: { 
        parent: i => i.baseOption.validator,
        attr: "minValue" 
      },
      maxValue: { 
        parent: i => i.baseOption.validator,
        attr: "maxValue" 
      },
      isMoney: { 
        parent: i => i.baseOption.validator,
        attr: "isMoney" 
      }
    }),
    /** @name 是否显示校验规则选择组件
     *  @author 王汝鹏
     *  @version 2019-12-17
     */
    showRuleSelect() {
      return new Set(['input', 'textarea']).has(this.value.node.type);
    },
    /** @name 是否显示范围设置组件
     *  @author 王汝鹏
     *  @version 2019-12-17
     */
    showLimit() {
      return new Set(['input', 'textarea']).has(this.value.node.type)
          && (new Set(['身份证', '手机号']).has(this.ruleSelected) === false);
    },
    /** @name 是否显示转大写设置组件
     *  @author 王汝鹏
     *  @version 2019-12-17
     */
    showMoney() {
      return new Set(['input', 'textarea']).has(this.value.node.type) && (new Set(['身份证', '手机号', '汉字']).has(this.ruleSelected) === false);
    },
    /** @name 最小值输入控制
     *  @author 王汝鹏
     *  @version 2019-12-18
     */
    minValueProxy: {
      get() { return this.minValue; },
      set(newValue) { 
        this.minValue = newValue; 
        this.refurbishTimer(() => {
          if (this.maxValue && (this.maxValue < this.minValue)) {
            this.minValue = undefined;
          }
        })
      }
    },
    /** @name 最大值输入控制
     *  @author 王汝鹏
     *  @version 2019-12-18
     */
    maxValueProxy: {
      get() { return this.maxValue; },
      set(newValue) { 
        this.maxValue = newValue;
        this.refurbishTimer(() => {
          if (this.minValue && (this.maxValue < this.minValue)) {
            this.maxValue = undefined;
          }
        })
      }
    }
  },
  methods: {
    /** @name 刷新定时器
     *  @author 王汝鹏
     *  @version 2019-12-18
     */
    refurbishTimer(callback) {
      clearTimeout(this.validatorTimer);
      this.validatorTimer = setTimeout(callback, 500);
    }
  },
  watch: {
    showMoney(newValue) { if (!newValue) this.isMoney = false; }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingValidatorRule.vue